import featuredMedia from '../blocks/featured-media';

export default {
  init() {
    // JavaScript to be fired on the home page
    window.video = new featuredMedia( $('.fs-video__video') );
    window.video.init();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/showreel-preview.js